import { atom } from 'jotai';

export const loadingAtom = atom<boolean>(false);
export const paidLoadingAtom = atom<boolean>(false);
